module.exports = __webpack_public_path__ + "img/tarifsgite.5b0f0f7c.jpg";